module.exports = "<div class=\"kng-cards kng-cards-sm kng-cards-md\">\r\n  <div class=\"kng-cards-item size-{{size}}\">\r\n    <ng-content></ng-content>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/task/cot-web/src/app/layout/kingswell/kng-cards/kng-cards.component.html
// module id = ../../../../../src/app/layout/kingswell/kng-cards/kng-cards.component.html
// module chunks = main